import React, { useEffect, useState } from 'react';
import AndrologySearchBar from './components/andrologySearchBar';
import { useDispatch, useSelector } from 'react-redux';
import AndrologyLandingPage from './components/andrologyLandingPage';
import {
  resetAndrologyData,
  setAndrologyData,
} from '../../../actions/andrologyAction';
import {
  permissionsList,
  permissionsWithAssignedIds,
} from '../../../api/constant';
import ProtectedComponent from '../../../common/ProtectedComponent';
import PageHeader from '../../../components/PageHeader';
import { ClinicalCustomerProfile } from '../ClinicalManagement/ClinicalCustomerProfile';
import { AndrologyCustomerProfile } from './components/AndrologyCustomerProfile';
import { resetPatientData } from '../../../actions';
import { getPatientDetailsApi } from '../../../api/patientApi';
import LoadingOverlay from '../../../components/LoadingOverlay';

export default function Andrology() {
  const selectedPatientData = useSelector(
    (state) => state.andrologyReducer.selectedPatientData,
  );

  const [loading,setLoading]=useState(false);

  const refresh = useSelector((state) => state.andrologyReducer.refresh);
  const dispatch = useDispatch();
  // const [selectedProcess, setSelectedProcess] = useState(null);

  const selectedProcess = useSelector(state => state.andrologyReducer.selectedProcess);

  const setSelectedProcess = (process) => {
    dispatch(setAndrologyData('selectedProcess', process));
  };

  const setPatient = (data) => {
    const selectedPatientData = {
      patient: data.patient,
      patientFiles: data.patientFiles,
      isFetched: true,
    };
    dispatch(setAndrologyData('selectedPatientData', selectedPatientData));
  };

  useEffect(() => {
    const getPatientLatestData = async () => {
      if (selectedPatientData && selectedPatientData.patient?.id) {
        const result = await getPatientDetailsApi(
          selectedPatientData.patient.id,
        );
        setPatient(result.data);
        setLoading(false);
        dispatch(setAndrologyData('refresh', false));
      }
    };
    if (refresh) {
      setLoading(true);
      setSelectedProcess('');
      getPatientLatestData();
  
    }else{
      setLoading(false);
      dispatch(setAndrologyData('refresh', false));
    }

    return ()=>{
      dispatch(resetAndrologyData());
      dispatch(resetPatientData());
    }
  }, [refresh]);

  return (
    <ProtectedComponent
      requiredPermission={
        permissionsWithAssignedIds[permissionsList.AndrologyManager]
      }
      className="app-container"
    >
      <PageHeader
        HeaderText="Fertility Management"
        Breadcrumb={[
          {
            name: 'Andrology Management',
            navigate: '/andrology',
          },
        ]}
      />
      <div className="container-fluid component-wrapper">
        <div style={{ width: '100%' }} className="theme-blush ">
          {!selectedProcess && selectedPatientData && (
            <AndrologySearchBar patientDataHandler={setPatient} />
          )}

          {/* {selectedPatientData && selectedPatientData.isFetched && (
            <AndrologyCustomerProfile />
          )} */}

          {selectedPatientData && selectedPatientData.isFetched && (
            <AndrologyLandingPage
              setSelectedProcess={setSelectedProcess}
              selectedProcess={selectedProcess}
            />
          )}
        </div>
        {loading && <LoadingOverlay message="Refreshing..." />}
      </div>
    </ProtectedComponent>
  );
}
